// extracted by mini-css-extract-plugin
module.exports = {"dimmer":"Dimmer_dimmer__Hp4Jr","dark":"Dimmer_dark__rY_FI"};